var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DROPS_STALE_TIME_MS, DROPS_FILTER_SECTION_MAP, DROPS_INITIAL_PAGE, DROPS_PER_PAGE, DROPS_TAB_LIST, DROPS_TAB_SECTION_MAP, DROPS_DEFAULT_FILTER, DROPS_DEFAULT_TAB, DropsTabStatus, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { isValidTab, } from 'root/src/client/v2/_pages/drops/helpers/drops.helper';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
import { redirect } from 'root/src/client/util/redirects';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
export class DropsListService {
    constructor(trpc) {
        this.trpc = trpc;
    }
    static getDropsQueryParams(params) {
        const { status: tab = DropsTabStatus.Live } = params;
        if (!isValidTab(tab)) {
            return {
                tab: DropsTabStatus.Live,
            };
        }
        return {
            tab,
        };
    }
    fetchDrops() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(DROPS_TAB_LIST.map((tab) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const filter = DROPS_DEFAULT_FILTER;
                    const dataFilter = DROPS_FILTER_SECTION_MAP[filter];
                    const section = DROPS_TAB_SECTION_MAP[tab.value];
                    const tabData = yield this.trpc.drops.getManyPaginated.fetchInfinite({
                        cursor: DROPS_INITIAL_PAGE,
                        limit: DROPS_PER_PAGE,
                        serializer: DropSerializer.LIST_VIEW,
                        section,
                        dataFilter,
                    }, { staleTime: DROPS_STALE_TIME_MS, initialCursor: DROPS_INITIAL_PAGE });
                    return Object.assign(Object.assign({}, tab), { item: {
                            items: tabData.pages.flatMap(result => result.items),
                        } });
                }
                catch (err) {
                    console.error(err);
                    return Object.assign(Object.assign({}, tab), { item: { items: [] } });
                }
            })));
        });
    }
    static getAvailableDropsTabs(drops) {
        return drops.filter(tab => { var _a, _b; return (_b = (_a = tab === null || tab === void 0 ? void 0 : tab.item) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length; });
    }
    static getFallbackDropsTabs() {
        return DROPS_TAB_LIST.map(tab => (Object.assign(Object.assign({}, tab), { item: { items: [] } })));
    }
    static redirectToDefaultParams(ctx) {
        redirect(ctx.res, routeUrls.drops({
            tab: DROPS_DEFAULT_TAB,
        }), true);
        return {
            props: {
                tabs: [],
            },
        };
    }
}
